import Types from './Types';

export const appStartup = () => ({
  type: Types.STARTUP
});



// WEBPACK FOOTER //
// ./src/actions/AppActions.js